import { useMutation } from "react-query";
import { UserManagePayload } from "./interfaces";
import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";

export function useUpdateClaim(onSuccess: () => void) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationFn: async (claim: UserManagePayload) => {
      try {
        return await apiContext.accountApis.updateClaims(claim);
      } catch (error: unknown) {
        if (error instanceof Response) {
          const errorMessage = await error.text();
          throw new Error(errorMessage);
        }
        throw new Error("Error in updating claims");
      }
    },
    onSuccess: onSuccess,
  });
}
